import { Message } from "./message";
import { IChatParticipant } from "./chat-participant";

export class Window
{
    constructor(participant: IChatParticipant, isLoadingHistory: boolean, isCollapsed: boolean, isOpen:boolean)
    {
        this.participant = participant;
        this.messages =  [];
        this.isLoadingHistory = isLoadingHistory;
        this.hasFocus = false; // This will be triggered when the 'newMessage' input gets the current focus
        this.isCollapsed = isCollapsed;
        this.hasMoreMessages = false;
        this.historyPage = 0;
        this.isOpen = isOpen;
    }

    public participant: IChatParticipant;    
    public messages: Message[] = [];
    public newMessage?: string = "";

    // UI Behavior properties
    public isCollapsed?: boolean = false; 
    public isOpen: boolean = false;
    public isLoadingHistory: boolean = false;
    public hasFocus: boolean = false;
    public hasMoreMessages: boolean = true;
    public historyPage: number = 0;
}
